import { addLayoutResizeListener, removeLayoutResizeListener } from '../lib/utils';
export function initScrollForTables(rootEl, selector = 'table') {
    rootEl = rootEl || document.body;
    return [].slice.apply(rootEl.querySelectorAll(selector))
        .filter((el) => el.tagName === 'TABLE')
        .map((tableEl) => initScrollForTable(tableEl));
}
export function initScrollForTable(tableEl) {
    var _a;
    const wrapperEl = document.createElement('div');
    const innerEl = document.createElement('div');
    wrapperEl.classList.add('ct-tableWrapper');
    innerEl.classList.add('ct-tableInner');
    wrapperEl.appendChild(innerEl);
    (_a = tableEl.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(wrapperEl, tableEl);
    innerEl.appendChild(tableEl);
    const scrollIndicatorTrack = document.createElement('div');
    const scrollIndicatorEl = document.createElement('div');
    scrollIndicatorTrack.classList.add('ct-scrollIndicatorTrack');
    scrollIndicatorEl.classList.add('ct-scrollIndicator');
    scrollIndicatorTrack.appendChild(scrollIndicatorEl);
    wrapperEl.appendChild(scrollIndicatorTrack);
    let hasOnScrollListener = false;
    onResize();
    onScroll();
    addLayoutResizeListener(onResize);
    function undo() {
        var _a;
        removeLayoutResizeListener(onResize);
        (_a = wrapperEl.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(tableEl, wrapperEl);
    }
    function onResize() {
        if (innerEl.offsetWidth >= innerEl.scrollWidth) {
            innerEl.removeEventListener('scroll', onScroll);
            innerEl.removeEventListener('scrollend', onScroll);
            indicateScroll({ left: false, right: false });
            scrollIndicatorEl.style.display = 'none';
            hasOnScrollListener = false;
        }
        else if (!hasOnScrollListener) {
            innerEl.addEventListener('scroll', onScroll);
            innerEl.addEventListener('scrollend', onScroll);
            scrollIndicatorEl.style.display = 'block';
            scrollIndicatorEl.style.width = `${(innerEl.offsetWidth / innerEl.scrollWidth) * 100}%`;
            hasOnScrollListener = true;
        }
    }
    function onScroll() {
        const amountScrolled = innerEl.scrollLeft;
        const maxScroll = innerEl.scrollWidth - innerEl.offsetWidth;
        scrollIndicatorEl.style.left = `${(amountScrolled / (maxScroll + innerEl.offsetWidth)) * 100}%`;
        indicateScroll({
            left: amountScrolled > 0,
            right: amountScrolled < maxScroll,
        });
    }
    function indicateScroll(args) {
        if (typeof args.left === 'boolean') {
            args.left ? wrapperEl.classList.add('has--scrollLeft') : wrapperEl.classList.remove('has--scrollLeft');
        }
        if (typeof args.right === 'boolean') {
            args.right ? wrapperEl.classList.add('has--scrollRight') : wrapperEl.classList.remove('has--scrollRight');
        }
    }
    return { undo, tableEl };
}
